import AES from 'crypto-js/aes'
import Crypto from 'crypto-js'

export function encrypt (data) {
  return AES.encrypt(data, process.env.VUE_APP_ENCRYPT_USER).toString()
}

export function decrypt (data) {
  return AES.decrypt(data, process.env.VUE_APP_ENCRYPT_USER).toString(Crypto.enc.Utf8)
}

export function base64_encode (data) {
  Crypto.enc.Base64.parse(data)
}

export function base64_decode (data) {
  Crypto.enc.Utf8.stringify(data)
}
